var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 65,
    viewBox: "0 0 80 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.25C0 37.8185 37.4315 64.25 54 64.25C70.5685 64.25 80 47.3185 80 30.75C80 14.1815 66.5685 0.75 50 0.75C33.4315 0.75 0 4.68146 0 21.25Z",
    fill: "#FFE5E4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_6529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3558 23.225L59.6716 20.5941C57.9298 22.3 55.1065 22.3 53.3656 20.5941C51.6238 18.8873 51.6238 16.1205 53.3647 14.4137L50.681 11.7828C50.2387 11.3483 49.5285 11.3391 49.0966 11.763L43.9689 16.7889L57.2473 29.8039L62.375 24.7779C62.807 24.3541 62.7985 23.6585 62.3558 23.225ZM26.6235 33.7906C26.1911 34.2134 26.1996 34.9091 26.6423 35.3435L29.3265 37.9744C31.0683 36.2694 33.8907 36.2704 35.6306 37.9762C37.371 39.683 37.371 42.4471 35.6334 44.1557L38.3176 46.7857C38.7594 47.2192 39.4696 47.2284 39.902 46.8046L56.4643 30.5714L43.1868 17.5564L26.6235 33.7906ZM49.0125 28.8761C49.2879 29.146 49.2879 29.5832 49.0125 29.8532L41.2716 37.4409C41.1339 37.5759 40.9534 37.6432 40.7729 37.6432C40.5924 37.6432 40.4124 37.5759 40.2747 37.4409C39.9993 37.171 39.9993 36.7338 40.2747 36.4638L48.0156 28.8761C48.2905 28.6061 48.737 28.6061 49.0125 28.8761ZM46.9637 26.868C47.2392 27.138 47.2392 27.5751 46.9637 27.8451L39.2224 35.4329C39.0847 35.5678 38.9042 35.6351 38.7237 35.6351C38.5432 35.6351 38.3627 35.5678 38.225 35.4329C37.9496 35.1629 37.9496 34.7257 38.225 34.4558L45.9664 26.868C46.2423 26.598 46.6883 26.598 46.9637 26.868ZM44.915 24.8595C45.1904 25.1294 45.1904 25.5666 44.915 25.8365L37.1741 33.4252C37.0364 33.5602 36.8559 33.6275 36.6754 33.6275C36.495 33.6275 36.3145 33.5602 36.1768 33.4252C35.9013 33.1553 35.9013 32.7181 36.1768 32.4481L43.9177 24.8595C44.1936 24.59 44.6396 24.59 44.915 24.8595Z",
    fill: "#FE5F55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_6529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 41,
    fill: "white",
    transform: "translate(21 6.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.3a51217d563be27e0bb2dfea8ef8f36b.svg";
export { ForwardRef as ReactComponent };